export interface OrganizationEntryScope {
  portfolioId: string
  productId: string
}

export type OrganizationMembership = {
  id: string
  role: string
  permissions: string[]
  createdAt: number
  updatedAt: number
  publicUserData?: {
    userId?: string
    firstName?: string | null
    lastName?: string | null
    identifier?: string | null
    imageUrl?: string
    hasImage?: boolean
  } | null
  publicMetadata?: Record<string, unknown>
  privateMetadata?: Record<string, unknown>
}

export enum OrganizationInvitationStatus {
  Pending = 'pending',
  Accepted = 'accepted',
  Revoked = 'revoked',
  Expired = 'expired',
}

export type OrganizationInvitation = {
  id: string
  emailAddress: string
  status: OrganizationInvitationStatus
  createdAt: number
  updatedAt: number
  expiresAt: number
  publicMetadata?: Record<string, unknown>
}

export enum OrganizationStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export interface OrganizationSummary {
  id: string
  name: string
  imageUrl: string | null
  membersCount: number
  maxAllowedMemberships: number
  seatsRemaining: number
  pendingInvitationsCount: number
  sector: string | undefined
  portfolios: number
  products: number
  status: OrganizationStatus
}

export interface OrganizationDetail extends OrganizationSummary {
  entryScope: OrganizationEntryScope | null
  memberships: OrganizationMembership[]
  pendingInvitations: OrganizationInvitation[]
}

interface OrganizationMemberPortfolioAssignment {
  id: string
  name: string
}

interface OrganizationMemberProductAssignment {
  id: string
  name: string
  portfolioId: string
}

export interface OrganizationMemberAssignments {
  portfolios: OrganizationMemberPortfolioAssignment[]
  products: OrganizationMemberProductAssignment[]
}
